var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-activity-wrapper"},[(_vm.selectedPage === 'PR')?_c('payment-request',{on:{"handlePage":function($event){_vm.selectedPage = $event}}}):_c('transaction-list',{on:{"handlePage":function($event){_vm.selectedPage = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }